"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pruneBoundaryOrphans = pruneBoundaryOrphans;
exports.pruneSpiceModelOrphans = pruneSpiceModelOrphans;
exports.prunePinOrphans = prunePinOrphans;
exports.pruneTieOrphans = pruneTieOrphans;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const boundary_conditions_denormalized_1 = require("../Types/boundary-conditions-denormalized");
function identityMap(signalIds) {
    const map = new Map();
    for (const id of signalIds) {
        map.set(id, id);
    }
    return map;
}
function pruneBoundaryOrphans(boundaries, signalIds, onOrphan) {
    if (boundaries.length === 0) {
        return [];
    }
    const identity = identityMap(signalIds);
    return boundaries.filter((boundary, index) => {
        let orphaned = false;
        (0, boundary_conditions_denormalized_1.remapSignalIdsInBoundaries)([boundary], identity, {
            onOrphan: (orphanId, fieldPath) => {
                orphaned = true;
                onOrphan?.(orphanId, fieldPath.replace(/^boundaries\[0\]/, `boundaries[${index}]`));
            },
        });
        return !orphaned;
    });
}
function pruneSpiceModelOrphans(submodels, signalIds, onOrphan) {
    return submodels.filter((submodel) => {
        if (!sigma_engine_shared_1.DesignModels.SPICE.isSubModelSigmaSubModel(submodel)) {
            return true;
        }
        const orphan = submodel.modelInfo.signalConnectionMap.find((item) => !signalIds.has(String(item.componentSignalId)));
        if (orphan !== undefined) {
            onOrphan?.(String(orphan.componentSignalId), `${submodel.subModelId}.signalConnectionMap`);
            return false;
        }
        return true;
    });
}
function prunePinOrphans(pins, signalIds, onOrphan) {
    return pins.filter((pin) => {
        if (pin.signalRef === null || pin.signalRef === undefined) {
            return true;
        }
        if (signalIds.has(pin.signalRef)) {
            return true;
        }
        onOrphan?.(pin.signalRef, `pins.${pin.name ?? pin.signalRef}`);
        return false;
    });
}
function pruneTieOrphans(signals, signalIds, onOrphan) {
    return signals.map((signal) => {
        if (signal.ties === undefined || signal.ties.length === 0) {
            return signal;
        }
        const ties = signal.ties.filter((tie, index) => {
            const targets = [
                tie.rootComponentSignalId,
                ...(tie.withConnections ?? []).flatMap((connection) => (connection.components ?? []).map((component) => component.rootComponentSignalId)),
            ].filter((target) => target !== undefined);
            const orphan = targets.find((target) => !signalIds.has(target));
            if (orphan === undefined) {
                return true;
            }
            onOrphan?.(orphan, `signals.${signal.id}.ties[${index}]`);
            return false;
        });
        if (ties.length === signal.ties.length) {
            return signal;
        }
        return { ...signal, ties: ties.length > 0 ? ties : undefined };
    });
}
//# sourceMappingURL=signal-id-orphan-pruning.js.map